jQuery(($) => {
  class HeaderNew {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._window = $(window);
      this._hamburger = this._element.find('.o-header-new__hamburger');
      this._mobileMenu = $('#mobile-menu');

      this._isInverted = this._element.hasClass('o-header-new--inverted');
      this._invertedElements = [
        ['m-navigation--inverted', this._element.find('.m-navigation--inverted')],
        ['m-navigation__item--inverted', this._element.find('.m-navigation__item--inverted')],
        ['a-nav-link--inverted', this._element.find('.a-nav-link--inverted')],
      ];
      this._invertedButtons = this._element.find('.a-button--inverted');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._window.on('scroll', this.handleScrollTrigger);
      this._hamburger.on('input-toggle:on', this.openMobileMenu);
      this._hamburger.on('input-toggle:off', this.closeMobileMenu);
      this._mobileMenu.on('drawer:close', this.handleMobileMenuClose);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Scroll Trigger
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleScrollTrigger = () => {
      if (!this._isInverted) return;

      if (this._window.scrollTop() > 40) {
        this._element.addClass('o-header-new--has-background');
        this.removeInvertHeader();
      } else {
        this._element.removeClass('o-header-new--has-background');
        this.invertHeader();
      }
    };

    removeInvertHeader = () => {
      if (!this._isInverted) return;

      this._element.removeClass('o-header-new--inverted');
      this._invertedElements.forEach(([className, elements]) => elements.removeClass(className));
      this._invertedButtons.removeClass('a-button--inverted').addClass('a-button--outline');
    };

    invertHeader = () => {
      if (!this._isInverted) return;

      this._element.addClass('o-header-new--inverted');
      this._invertedElements.forEach(([className, elements]) => elements.addClass(className));
      this._invertedButtons.removeClass('a-button--outline').addClass('a-button--inverted');
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Open Mobile Menu
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    openMobileMenu = () => {
      this._mobileMenu.drawer('handleOpen');
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Close Mobile Menu
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    closeMobileMenu = () => {
      this._mobileMenu.drawer('handleClose');
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Mobile Menu Close
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleMobileMenuClose = () => {
      this._hamburger.input_toggle('toggleOff');
      this._hamburger.find('.a-hamburger__input').focus();
    };
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.header_new = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined') _[i].header_new = new HeaderNew(_[i], opt);
      else ret = _[i].header_new[opt].apply(_[i].header_new, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-header-new').header_new();
});
